<template>
  <div class="table-action-wrapper">
    <div class="date-range-group d-flex align-items-center">
      <DatePicker :value="query.date.value" :preset-dates="presetDates" range multi-calendars placeholder="Date Range" @change="changeDate" />
      <Select :options="dateByOptions" placeholder="By Date Created" data-title="By" class="has-tip date-picker-left" :value="query.date_by.value" @changeValue="changeDateBy"></Select>
    </div>
    <Select :options="statusOptions" placeholder="Status" data-title="Status" class="has-tip" :value="query?.status?.value" @changeValue="changeStatus"></Select>
    <Select :options="latestShipDateOptions" placeholder="Est. Shipping Date" data-title="Latest Ship Date" class="has-tip" :value="query.latest_ship_date.value" @changeValue="changeLatestShipDate"></Select>
    <Select :options="orderTypeOptions" placeholder="Order Type" data-title="Order Type" class="has-tip" :value="query.order_type.value" @changeValue="changeOrderType"></Select>
    <Select :options="subOrdersOptions" placeholder="Sub-orders" data-title="Sub-orders" class="has-tip" :value="query.sub_orders.value" @changeValue="changeSubOrder"></Select>
    <Select source="sale-account/search" placeholder="Sale Account" :value="query.account_id.value" @changeValue="changeAccountId"></Select>
    <Select source="vendor-account/search" placeholder="Vendor Account" :value="query.vendor_id.value" @changeValue="changeVendorId"></Select>
    <Select source="user/search" type="auto" field="order.user_read" placeholder="Seller" :value="query.user_ids.value" @changeValue="changeUserId"></Select>
    <Select source="term/search" placeholder="Category" :value="query.term_id.value" @changeValue="changeTermId"></Select>
    <Select :options="labelOptions" placeholder="Label" data-title="Label" class="has-tip" :value="query.label.value" @changeValue="changeLabel"></Select>
    <div class="flag-filters">
      <span class="flag-icon" :data-selected="query.flag.value" @click="toggleFlagBox"><i class="ti ti-flag-filled flag"></i></span>
      <ul class="flags" ref="flagsList">
        <li class="radio-container" v-for="(object, flag) in flagOptions" :key="flag"><input type="radio" name="filters[order_flag]" :value="flag" @click="changeFlag" /><span :class="`checkmark choose-flag ${object.color}`"></span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/DatePicker.vue'
import moment from 'moment'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      query: {
        date: {
          value: [],
          valueLabel: '',
          fieldLabel: 'Date Range',
          group: 'date',
          format: '{{ date_by.valueLabel }}: {{ date.valueLabel }}'
        },
        date_by: {
          value: null,
          defaultValue: 'date_created',
          valueLabel: '',
          defaultValueLabel: 'Date Created',
          fieldLabel: 'By',
          group: 'date'
        },
        status: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Status'
        },
        latest_ship_date: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Latest Ship Date'
        },
        order_type: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Type'
        },
        sub_orders: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Sub Order'
        },
        user_ids: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Seller'
        },
        term_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Category'
        },
        account_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Account'
        },
        vendor_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Vendor'
        },
        label: {
          value: '',
          valueLabel: '',
          fieldLabel: 'Label'
        },
        flag: {
          value: 'all',
          valueLabel: '',
          fieldLabel: 'Flag'
        }
      },
      presetDates: ['Today', 'Yesterday', 'This Week', 'Last Week', '7 Days Ago', 'This Month', 'Last Month', '30 Days Ago', '3 Months Ago', '90 Days Ago', 'This Year']
    }
  },
  created() {
    this.query = Object.assign(this.query, this.config?.query)
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    dateByOptions() {
      return this.extraAttributes?.date_by || []
    },
    orderTypeOptions() {
      return this.extraAttributes?.order_type
    },
    subOrdersOptions() {
      return this.extraAttributes?.sub_orders
    },
    flagOptions() {
      return this.extraAttributes?.flags
    },
    statusOptions() {
      return Object.values(this.extraAttributes?.statuses || [])
    },
    latestShipDateOptions() {
      return Object.values(this.extraAttributes?.latest_ship_dates || [])
    },
    labelOptions() {
      return Object.values(this.extraAttributes?.labels || [])
    }
  },
  methods: {
    changeDate(e) {
      if (e === null) {
        this.query.date = Object.assign(this.query.date, {
          value: null,
          valueLabel: ''
        })
      } else if (_.isArray(e)) {
        this.query.date = Object.assign(this.query.date, {
          value: e.map((item) => moment(item).format('YYYY-MM-DD')),
          valueLabel: e.map((item) => moment(item).format('YYYY/MM/DD')).join(' - ')
        })
      } else {
        return
      }
      this.$emit('change-filters', this.query)
    },
    changeDateBy(value, e) {
      this.query.date_by = Object.assign(this.query.date_by, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeStatus(value, e) {
      this.query.status = Object.assign(this.query.status, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeLatestShipDate(value, e) {
      this.query.latest_ship_date = Object.assign(this.query.latest_ship_date, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeOrderType(value, e) {
      this.query.order_type = Object.assign(this.query.order_type, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeSubOrder(value, e) {
      this.query.sub_orders = Object.assign(this.query.sub_orders, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeAccountId(value, e) {
      this.query.account_id = Object.assign(this.query.account_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeVendorId(value, e) {
      this.query.vendor_id = Object.assign(this.query.vendor_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeUserId(value, e) {
      this.query.user_ids = Object.assign(this.query.user_ids, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeTermId(value, e) {
      this.query.term_id = Object.assign(this.query.term_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeLabel(value, e) {
      this.query.label = Object.assign(this.query.label, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    toggleFlagBox() {
      if (['none', ''].indexOf(this.$refs.flagsList.style.display) != -1) {
        this.$refs.flagsList.style.display = 'flex'
      } else {
        this.$refs.flagsList.style.display = 'none'
      }
    },
    changeFlag(e) {
      this.query.flag = Object.assign(this.query.flag, {
        value: e.currentTarget.value,
        valueLabel: e.currentTarget.value
      })
      this.$refs.flagsList.style.display = 'none'
      this.$emit('change-filters', this.query)
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.date-range-group {
  background: #fff;
  border-radius: 25px;
  border: 1px solid #ced4da;
  max-width: 450px;
  min-width: 450px;
  .multiselect .multiselect-wrapper,
  .dp__input {
    border: 0 !important;
    border-color: transparent !important;
    box-shadow: 0 0 0 !important;
    background: transparent !important;
  }
  .dp__main {
    flex: 1;
  }
  .select {
    width: 200px;
  }
}
</style>
